// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Dn-z","tupacHeader":"En-z","tupacHeader2":"Fn-z","tupacMenu":"Gn-z","tupacMenu2":"Hn-z","tupacMain":"In-z","tupacMain2":"Jn-z"};